export default "__VITE_ASSET__ClBQ1gQI__"